import React, { Component } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { Card, Pagination, Row, Col, Container } from 'react-bootstrap'

// Imports de imágenes
import img1 from '../Rehabilitacion/img1.jpg'
import img2 from '../Rehabilitacion/img2.jpg'
import img25 from '../Rehabilitacion/img25.jpg'
import img26 from '../Rehabilitacion/img26.jpg'
import img27 from '../Rehabilitacion/img27.jpg'
import img29 from '../Rehabilitacion/img29.jpg'
import img30 from '../Rehabilitacion/img30.jpg'
import img31 from '../Rehabilitacion/img31.jpg'
import img32 from '../Rehabilitacion/img32.jpg'

export class Rehabilitation extends Component {
    render() {
        const rehabItems = [
            { img: img1 }, { img: img2 }, { img: img26 },
            { img: img27 }, { img: img29 }, { img: img30 },
            { img: img25 }, { img: img31 }, { img: img32 }
        ];

        return (
            <div>
                <Header />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Rehabilitation</h1>
                        </Col>
                    </Row>
                    <br />

                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item active>{1}</Pagination.Item>
                        <Pagination.Item href="/en/Rehabilitation2">{2}</Pagination.Item>
                        <Pagination.Item href="/en/Rehabilitation3">{3}</Pagination.Item>
                    </Pagination>

                    {/* Mantenemos el estándar de 2 columnas por fila para imágenes con texto denso */}
                    <Row className="justify-content-center g-4">
                        {rehabItems.map((item, idx) => (
                            <Col key={idx} xs={12} lg={6}>
                                <Card className="shadow-sm border-0 h-100">
                                    <Card.Body className="p-3">
                                        <Card.Img 
                                            variant="top" 
                                            src={item.img} 
                                            style={{ 
                                                width: '100%', 
                                                height: 'auto', 
                                                objectFit: 'contain' 
                                            }} 
                                        />
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    <br />
                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item active>{1}</Pagination.Item>
                        <Pagination.Item href="/en/Rehabilitation2">{2}</Pagination.Item>
                        <Pagination.Item href="/en/Rehabilitation3">{3}</Pagination.Item>
                    </Pagination>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}